import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";

export default function useMutateCandidateAvatarFromUrl() {
  const client = useQueryClient();
  const axios = useAxios();

  return {
    mutation: useMutation({
      mutationFn: ({ candidate, url, source }) =>
        axios.post(`/candidate/${candidate.uuid}/avatar-from-url`, {
          url,
          source,
        }),
      onSuccess: (data, variables) => {
        client.setQueryData(
          ["candidateDetails", variables.candidate.uuid],
          data
        );
      },
    }),
  };
}
